import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// TODO: get rid of this component

@Component({
  selector: 'rt-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.active]': 'active',
  },
})
export class ItemComponent {
  @Input() public active: boolean = false;
}
